
import Vue from 'vue'
import Component from 'vue-class-component'

// @ts-ignore
import SwaggerUI from 'swagger-ui'
import 'swagger-ui/dist/swagger-ui.css'

import OpenAPIService from '../services/OpenAPIService'

@Component({})
export default class Swagger extends Vue {
  private mounted() {
    this.buildSwagger()
  }

  private async buildSwagger() {
    const specFile = await OpenAPIService.get()
    SwaggerUI({
      docExpansion: 'none',
      dom_id: '#swagger',
      filter: true,
      operationsSorter: 'method',
      spec: specFile,
      syntaxHighlight: false,
      tagsSorter: 'alpha',
      tryItOutEnabled: false,
    })
  }
}
